import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const GST_Audit_Services = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title gst_classification_title dot_centet d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/gst_audit_services_icone.png'></img>
                                    <Title text="GST Audit Services" className="custom-heading" />
                                </div>
                                <ul className='d-flex align-items-center'>
                                    <li className='green'>Ensuring Compliance</li>
                                    <li className='orange'>Strengthening Accuracy</li>
                                    <li className='light-blue'>Optimizing Tax Efficiency</li>
                                </ul>
                            </div>
                            <div className='discriptions'>
                                <p>With over <strong>three years since the implementation of Goods and Services Tax (GST)</strong> in India, businesses have been navigating the complexities of <strong>GST compliance, input-output reconciliations, tax filings, and audits.</strong> To ensure transparency and adherence to regulations, the GST law mandates audits for specific categories of taxpayers.</p>
                                <p>At <strong>Vanani & Associates,</strong> we offer <strong>comprehensive GST audit services,</strong> helping businesses stay compliant while optimizing their tax efficiency. Our experienced team of <strong>chartered accountants and tax experts</strong> ensures that your <strong>financial records, GST returns, and reconciliations</strong> are accurate and in full compliance with GST regulations.</p>
                            </div>
                            <section className="gst-audit-section my-5 radius">
                                <div className="container">
                                    <div className="gst-audit-wrapper">
                                        <div className="gst-audit-icon">
                                            <img src="/images/industry_specific.png" alt="GST Audit" />
                                        </div>
                                        <div className="gst-audit-content ">
                                            <h2>What is a <span>GST Audit?</span></h2>
                                            <div className="gst-audit-highlight mb-0">
                                                <ul>
                                                    <li>A <strong>GST audit</strong> is a structured review of a taxpayer’s <strong>financial records, returns, and other documents</strong> to verify the <strong>correctness of turnover, input tax credit (ITC), tax payments, and refund claims.</strong> The primary objective is to detect errors, prevent tax discrepancies, and ensure <strong>compliance with GST provisions.</strong></li>
                                                    <li className='mt-3'>Under <strong>Section 35(5) of the CGST Act,</strong> businesses exceeding the prescribed <strong>turnover threshold of ₹5 crores</strong> must undergo a GST audit conducted by a <strong>Chartered Accountant (CA) or Cost Accountant (CMA)</strong> and submit <strong>Form GSTR-9C,</strong> a reconciliation statement along with audited financial statements.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="check_list_wrap mt-2 compliance_checklist_flow audit_services gst_audit_applicability">
                                <h4 className="mt-2 mb-4">Applicability of <sapn className="key_features">GST Audit</sapn></h4>
                                <div className="checklist-flow">
                                    <div className="checklist-item">
                                        <span className="check-icon">📊</span>
                                        <div className="check-content">
                                            <strong>Turnover-Based GST Audit</strong>
                                            <ul>
                                                <li>Businesses with an annual aggregate turnover exceeding ₹5 crores in a financial year must undergo a GST audit and file GSTR-9C (reconciliation statement).</li>
                                                <li>GSTR-9 (Annual Return) is mandatory for businesses with turnover above ₹2 crores but optional for those below ₹2 crores.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="checklist-item">
                                        <span className="check-icon">🏛️</span>
                                        <div className="check-content">
                                            <strong>Departmental GST Audit</strong>
                                            <ul>
                                                <li>Conducted by GST authorities based on risk assessment or random selection of businesses.</li>
                                                <li>Authorities issue a notice at least 15 days in advance and complete the audit within three months (extendable by another six months).</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="checklist-item">
                                        <span className="check-icon">🔍</span>
                                        <div className="check-content">
                                            <strong>Special GST Audit</strong>
                                            <ul>
                                                <li>Initiated when the Assistant Commissioner suspects underreporting, incorrect ITC claims, or tax evasion.</li>
                                                <li>Conducted by a chartered accountant or cost accountant appointed by the Commissioner of GST.</li>
                                                <li>The report must be submitted within 90 days (extendable by another 90 days).</li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className='Key_Objectives_of_gst_audit mt-5'>
                                <div className='col-md-12'>
                                    <div className='check_list_wrap mt-2'>
                                        <h4 className='mt-0 mb-3'>Key Objectives of a GST Audit</h4>
                                        <ul>
                                            <li><strong>Ensuring GST Compliance </strong>Verifying that businesses follow GST provisions, avoiding penalties and disputes.</li>
                                            <li><strong>Detecting Errors & Discrepancies </strong>Identifying incorrect ITC claims, underpayment, or excess tax payments.</li>
                                            <li><strong>Optimizing Input Tax Credit (ITC) </strong>Ensuring businesses claim legitimate ITC, maximizing tax efficiency.</li>
                                            <li><strong>Reviewing GST Transactions </strong>Analyzing invoices, GST returns, and financial records to detect misreporting.</li>
                                            <li><strong>Preparing for GST Scrutiny & Assessments </strong>Assisting businesses in departmental audits, reducing litigation risks.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <section>
                                <h4 className='mt-5 mb-4'>
                                    <span className="key_features">Types</span> of GST Audits
                                </h4>
                                <div className='row'>

                                    {/* GST Annual Audit */}
                                    <div className="col-lg-6 col-md-12 box_desing_wrapper our_services refund_services">
                                        <div className="inr_box">
                                            <div className="box-icon-text d-flex mb-3">
                                                <img src="/images/completed-control.png" alt="GST Annual Audit" />
                                                <h2>GST Annual Audit (GSTR-9 & GSTR-9C Audit)</h2>
                                            </div>
                                            <ul>
                                                <li className='mb-2'>Applicable to businesses exceeding <strong>₹5 crores turnover.</strong></li>
                                                <li className='mb-2'>Includes <strong>reconciliation of financial records</strong> with GST returns and <strong>filing of GSTR-9C.</strong></li>
                                                <li>Ensures <strong>correct ITC claims, tax payments, and compliance.</strong></li>
                                            </ul>
                                            <h5 className="number">01</h5>
                                        </div>
                                    </div>

                                    {/* Departmental GST Audit */}
                                    <div className="col-lg-6 col-md-12 box_desing_wrapper our_services refund_services">
                                        <div className="inr_box">
                                            <div className="box-icon-text d-flex mb-3">
                                                <img src="/images/department.png" alt="Departmental Audit" />
                                                <h2>Departmental GST Audit</h2>
                                            </div>
                                            <ul>
                                                <li className='mb-2'>Conducted by GST authorities to <strong>verify records, invoices, ITC claims, and tax payments.</strong></li>
                                                <li>Findings may lead to <strong>additional tax demand, penalties, or clarifications.</strong></li>
                                            </ul>
                                            <h5 className="number">02</h5>
                                        </div>
                                    </div>

                                    {/* Special GST Audit */}
                                    <div className="col-lg-6 col-md-12 box_desing_wrapper our_services refund_services">
                                        <div className="inr_box">
                                            <div className="box-icon-text d-flex mb-3">
                                                <img src="/images/business-report.png" alt="Special GST Audit" />
                                                <h2>Special GST Audit</h2>
                                            </div>
                                            <ul>
                                                <li className='mb-2'>Ordered when authorities <strong>suspect tax evasion or incorrect tax declarations.</strong></li>
                                                <li>Conducted by an <strong>independent CA/CMA,</strong> with findings directly reported to GST officers.</li>
                                            </ul>
                                            <h5 className="number">03</h5>
                                        </div>
                                    </div>

                                </div>
                            </section>

                            <section className="scn-section-v2 mt-4 mb-4 pt-3 pb-3 radius">
                                <h4 className='mb-2'>
                                    GST Audit Procedure at <span className="key_features">Vanani & Associates</span>
                                </h4>
                                <p>Our <strong>structured GST audit methodology</strong> ensures a smooth and hassle-free audit experience for businesses.</p>
                                <div className="scn-wrapper mt-4">

                                    {/* Step 1 */}
                                    <div className="scn-card-v2">
                                        <div className="scn-icon-box">
                                            <img src="/images/strategy-board.png" alt="Pre-Audit Planning" />
                                        </div>
                                        <div className="scn-content-box">
                                            <h3>Pre-Audit Planning & Risk Assessment</h3>
                                            <div className="scn-points">
                                                <div className="point">Understanding the <strong>business model, transactions, and GST compliance status.</strong></div>
                                                <div className="point">Identifying <strong>critical areas</strong> like ITC claims, reverse charge mechanism (RCM), tax rates, and exemptions.</div>
                                                <div className="point">Reviewing <strong>financial records and past GST filings.</strong></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Step 2 */}
                                    <div className="scn-card-v2">
                                        <div className="scn-icon-box">
                                            <img src="/images/combo-chart--v1.png" alt="GST Records Review" />
                                        </div>
                                        <div className="scn-content-box">
                                            <h3>Review of GST Records & Reconciliation</h3>
                                            <div className="scn-points">
                                                <div className="point"><strong>Verification of GST returns</strong> – Examining <strong>GSTR-1, GSTR-3B, GSTR-9, and GSTR-9C.</strong></div>
                                                <div className="point"><strong>Cross-checking GSTR-3B vs GSTR-1 and GSTR-2A</strong> – Ensuring proper ITC claims and tax payments.</div>
                                                <div className="point"><strong>Invoice Matching & Tax Rate Verification</strong> – Checking invoices for <strong>accuracy, proper classification, and compliance.</strong></div>
                                                <div className="point"><strong>Reversal of ITC on Unpaid Invoices</strong> – Ensuring ITC is <strong>reversed if payment is not made within 180 days.</strong></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Step 3 */}
                                    <div className="scn-card-v2">
                                        <div className="scn-icon-box">
                                            <img src="/images/industry_specific.png" alt="Compliance Review" />
                                        </div>
                                        <div className="scn-content-box">
                                            <h3>Compliance & Documentation Review</h3>
                                            <div className="scn-points">
                                                <div className="point"><strong>E-Way Bill Compliance</strong> – Ensuring e-way bills are generated for <strong>invoices exceeding ₹50,000.</strong></div>
                                                <div className="point"><strong>Stock Register & GST Classification</strong> – Verifying stock movement and tax applicability.</div>
                                                <div className="point"><strong>Industry-Specific GST Provisions</strong> – Checking compliance with <strong>sector-specific GST regulations.</strong></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Step 4 */}
                                    <div className="scn-card-v2">
                                        <div className="scn-icon-box">
                                            <img src="/images/contact-section-website.png" alt="Audit Reporting" />
                                        </div>
                                        <div className="scn-content-box">
                                            <h3>Audit Reporting & Filing of GSTR-9C</h3>
                                            <div className="scn-points">
                                                <div className="point">Preparing a <strong>detailed audit report</strong> covering:</div>
                                                <ul className='px-3 mb-0'>
                                                    <li className='mb-2'>Reconciliation of <strong>GST turnover and financial statements.</strong></li>
                                                    <li className='mb-2'>Tax liabilities and additional dues.</li>
                                                    <li><strong>Auditor’s recommendations for rectifications and improvements.</strong></li>
                                                </ul>
                                                <div className="point">Filing <strong>GSTR-9C and submitting final audit findings.</strong></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Step 5 */}
                                    <div className="scn-card-v2">
                                        <div className="scn-icon-box">
                                            <img src="/images/customer-support.png" alt="Post-Audit Advisory" />
                                        </div>
                                        <div className="scn-content-box">
                                            <h3>Post-Audit Advisory & Compliance Support</h3>
                                            <div className="scn-points">
                                                <div className="point"><strong>Assisting in rectifications and ensuring correct reporting in future GST returns.</strong></div>
                                                <div className="point"><strong>Preparing for departmental GST audits and responding to tax notices & queries.</strong></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </section>
                            <section className="gst-audit-importance mt-5 mb-5 pt-4 pb-4 radius">
                                <div className="container">
                                    <h4 class="mb-4"> Why is a <span class="key_features">GST Audit Important?</span></h4>
                                    <div className="importance-list">

                                        <div className="importance-item">
                                            <div className="icon-badge">✔</div>
                                            <div className="content p-0">
                                                <h3>Ensures GST Compliance</h3>
                                                <p>Prevents tax disputes, penalties, and scrutiny from authorities.</p>
                                            </div>
                                        </div>

                                        <div className="importance-item">
                                            <div className="icon-badge">🔎</div>
                                            <div className="content p-0">
                                                <h3>Detects Errors & Reduces Litigation Risk</h3>
                                                <p>Identifies tax discrepancies before regulatory audits.</p>
                                            </div>
                                        </div>

                                        <div className="importance-item">
                                            <div className="icon-badge">💰</div>
                                            <div className="content p-0">
                                                <h3>Strengthens ITC Claims</h3>
                                                <p>Ensures businesses <strong>claim eligible ITC</strong> and avoid tax losses.</p>
                                            </div>
                                        </div>

                                        <div className="importance-item">
                                            <div className="icon-badge">📊</div>
                                            <div className="content p-0">
                                                <h3>Enhances Financial Transparency</h3>
                                                <p>Aligns GST records with <strong>financial statements</strong> for accuracy.</p>
                                            </div>
                                        </div>

                                        <div className="importance-item mb-0">
                                            <div className="icon-badge">🛡️</div>
                                            <div className="content p-0">
                                                <h3>Prepares for Departmental Audits</h3>
                                                <p>Reduces risks of <strong>tax scrutiny and investigations.</strong></p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>

                            <section className="gst-why-choose mt-3 pt-3 radius">
                                <div className="container">
                                    <h4 class="mb-4" text-center> Why Choose <span class="key_features"> Vanani & Associates</span> for GST Audit?</h4>

                                    <div className="choose-grid">
                                        <div className="choose-card">
                                            <div className="choose-icon">
                                                <img src="/images/customized_support.png" alt="Professionals" />
                                            </div>
                                            <h3>Experienced GST Professionals</h3>
                                            <p className='text-center'>Our team of chartered accountants and GST experts ensures a meticulous audit process.</p>
                                        </div>

                                        <div className="choose-card">
                                            <div className="choose-icon">
                                                <img src="/images/compliance_check.png" alt="Analysis" />
                                            </div>
                                            <h3>In-Depth Analysis</h3>
                                            <p className='text-center'>We go beyond basic compliance to detect hidden tax risks and savings.</p>
                                        </div>

                                        <div className="choose-card">
                                            <div className="choose-icon">
                                                <img src="/images/digital_tools.png" alt="Digital Tools" />
                                            </div>
                                            <h3>Digital Audit Tools</h3>
                                            <p className='text-center'>We leverage <strong>automation and GST software</strong> for efficient data reconciliation.</p>
                                        </div>

                                        <div className="choose-card">
                                            <div className="choose-icon">
                                                <img src="/images/reduction.png" alt="Risk Approach" />
                                            </div>
                                            <h3>Risk-Based Approach</h3>
                                            <p className='text-center'>Our audits focus on <strong>identifying potential tax liabilities</strong> before they escalate into disputes.</p>
                                        </div>

                                        <div className="choose-card">
                                            <div className="choose-icon">
                                                <img src="/images/expert_guidance.png" alt="Support" />
                                            </div>
                                            <h3>End-to-End Support</h3>
                                            <p className='text-center'>From <strong>audit execution to GSTR-9C filing and departmental audit representation</strong> – we handle it all.</p>
                                        </div>

                                    </div>
                                </div>
                            </section>

                            <section className="gst-audit-cta mt-4">
                                <div className="container">
                                    <div className="cta-box">
                                        <h2>Get Your <span>GST Audit Done by Experts</span></h2>
                                        <p className="intro">
                                            GST compliance is non-negotiable for businesses, and a thorough GST audit is key
                                            to mitigating risks and ensuring accurate reporting.
                                        </p>
                                        <p className="intro">If you need assistance with:</p>

                                        <ul className="cta-list">
                                            <strong><li>Turnover-based GST audit (GSTR-9 &amp; GSTR-9C)</li>
                                                <li>Departmental GST audit representation</li>
                                                <li>Special GST audits ordered by authorities</li>
                                                <li>ITC verification and compliance health check</li></strong>
                                        </ul>

                                        <div className="cta-footer">
                                            <p>📩 Contact <strong>Vanani &amp; Associates</strong> today to schedule your <strong>GST audit consultation</strong> and ensure seamless compliance with expert guidance! 🚀</p>
                                        </div>
                                    </div>
                                </div>
                            </section>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GST_Audit_Services;
